export const name = 'cyclicTabbing' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'

export const CyclicTabbingSymbol = Symbol('CyclicTabbing')
